<div style="    display: grid;
    grid-template-columns: repeat(3, 1fr);
    justify-content: center;
    align-items: center;
    margin-top: 5px;
">
  <div>
      <pre>Showing {{ startEntry }} - {{ endEntry }} of {{ recordCount }} entries
  </pre>
  </div>

  <div>
  </div>

  <div>

    <ngb-pagination
      (pageChange)="onPageChange($event)"
      [(page)]="page"
      [boundaryLinks]="true"
      [collectionSize]="recordCount"
      [directionLinks]="true"
      [disabled]="disabled"
      [maxSize]="3"
      [pageSize]="pageSize"
      aria-label="Default pagination"
      class="d-flex justify-content-end"
    >
    </ngb-pagination>
  </div>
</div>
